export default __webpack_public_path__ + "static/media/question_mark.e29614e7.svg";